import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Globe } from "lucide-react";
import { Seal } from "@/components/site/Seal";
import { CONTACT } from "@/lib/data";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-maroon text-cream relative overflow-hidden">
    <div className="absolute -right-20 -bottom-24 w-[420px] h-[420px] opacity-[0.06] pointer-events-none">
      <Seal className="w-full h-full" />
    </div>

    <div className="max-w-[1400px] mx-auto px-5 md:px-10 pt-24 pb-12 relative">
      <div className="grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-6">
          <p className="text-gold text-xs uppercase tracking-[0.3em] mb-6">Twins Media</p>
          <h2 className="font-display italic text-4xl md:text-6xl leading-[1.05] text-cream max-w-xl">
            Defining Your Brands <br /> Since <span className="text-gold not-italic">1997</span>
          </h2>
          <p className="mt-8 text-cream/70 text-sm tracking-wide max-w-md">
            Railway Station Advertising • Digital Display Screens • Outdoor Hoardings • Transit Media • Brand Promotion
          </p>
        </div>

        <div className="lg:col-span-3">
          <p className="text-gold text-xs uppercase tracking-[0.25em] mb-6">Navigate</p>
          <ul className="space-y-4 text-cream/80">
            {[["Home", "/"], ["About Us", "/about"], ["Services", "/services"], ["Network", "/network"], ["Contact", "/contact"]].map(([l, to]) => (
              <li key={to}>
                <Link to={to} className="hover:text-gold transition-colors duration-300">{l}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-3">
          <p className="text-gold text-xs uppercase tracking-[0.25em] mb-6">Reach Us</p>
          <ul className="space-y-4 text-cream/80 text-sm">
            <li className="flex gap-3"><MapPin size={16} className="text-gold shrink-0 mt-0.5" /> Manipal, Karnataka, India</li>
            <li className="flex gap-3"><Phone size={16} className="text-gold shrink-0 mt-0.5" /> <a href="tel:+919980549123" className="hover:text-gold">{CONTACT.phone}</a></li>
            <li className="flex gap-3"><Mail size={16} className="text-gold shrink-0 mt-0.5" /> <a href={`mailto:${CONTACT.email}`} className="hover:text-gold break-all">{CONTACT.email}</a></li>
            <li className="flex gap-3"><Globe size={16} className="text-gold shrink-0 mt-0.5" /> {CONTACT.website}</li>
          </ul>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-cream/15 flex flex-col md:flex-row items-center justify-between gap-5 text-cream/50 text-xs tracking-wide">
        <p>© {new Date().getFullYear()} Twins Media. All rights reserved.</p>
        <nav className="flex items-center gap-5" aria-label="Legal">
          <Link to="/privacy-policy" data-testid="footer-privacy-link" className="hover:text-gold transition-colors duration-300">Privacy Policy</Link>
          <span className="h-3 w-px bg-cream/20" />
          <Link to="/terms" data-testid="footer-terms-link" className="hover:text-gold transition-colors duration-300">Terms &amp; Conditions</Link>
        </nav>
        <p>The Railway Advertiser</p>
      </div>

      <p className="mt-6 text-center text-cream/35 text-[11px] tracking-wide">
        Powered by{" "}
        <a
          href="https://www.victinet.com/"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-victinet-link"
          className="hover:text-gold transition-colors duration-300"
        >
          Victinet
        </a>
      </p>
    </div>
  </footer>
);
